"use strict";
define('components/payment_pref',[], function() {

    var paymentPrefComponent = {
        init: function(node) {
            node.find('.bank-info').each(function() {
                var bankInfo = $(this);
                bankInfo.find('.bank-address').on('jsq:objectSelected', function(e, fieldId, name, type, id, subType) {
                    paymentPrefComponent._handleAddressChange(e, bankInfo);
                });
                bankInfo.find('.bank-address').change(function(e) {
                    paymentPrefComponent._handleAddressChange(e, bankInfo);
                });
            });
        },

        _handleAddressChange: function(e, bankInfo) {
            // Unvail the right routing info fields based on bank address
            // for both the beneficiary and intermediary banks
            var field = $(e.target);
            var bankAddress = field.closest('.bank-address');

            // Get the country name based on StateID or CountryName
            var countryName = null;
            var stateId = bankAddress.find('.state input[name=object_id]').val();
            var stateCode = bankAddress.find('.state input[name=object_name]').val();
            if (stateId || (stateCode && US_STATE_CODES.indexOf(stateCode.toUpperCase()) >= 0) ) {
                countryName = 'United States';
            } else {
                countryName = bankAddress.find('.country input[name=object_name]').val();
            }

            // Set the visibilty of the routing info based on the bank's country
            var routingInfoMsgRow = bankInfo.find('.routing-info-msg');
            var usBankInfoRow = bankInfo.find('.us-bank-info');
            var intlBankInfoRow = bankInfo.find('.intl-bank-info');
            if (!countryName) {
                routingInfoMsgRow.removeClass('hidden');
                usBankInfoRow.addClass('hidden')
                             .find('input')
                             .val('');
                intlBankInfoRow.addClass('hidden')
                               .find('input')
                               .val('');
            } else if (countryName === 'United States') {
                routingInfoMsgRow.addClass('hidden');
                usBankInfoRow.removeClass('hidden');
                intlBankInfoRow.addClass('hidden')
                               .find('input')
                               .val('');
            } else {
                routingInfoMsgRow.addClass('hidden');
                usBankInfoRow.addClass('hidden')
                             .find('input')
                             .val('');
                intlBankInfoRow.removeClass('hidden');
            }
        }
    };

    var US_STATE_CODES = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID',
                          'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO',
                          'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA',
                          'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'AS',
                          'FM', 'GU', 'MH', 'MP', 'PW', 'PR', 'VI'];

    return paymentPrefComponent;
});

